import Axios, { AxiosRequestConfig } from "axios";

export const addToTable = (prev: IData<any>, pageSize: number, newItem: any): IData<any> => {
    let dataCopy = [...(prev?.data || [])];

    //if array of items
    if (newItem.length) {
        if (newItem.length > pageSize) dataCopy = newItem.slice(0, pageSize);
        else {
            if (dataCopy.length == pageSize) {
                dataCopy = dataCopy.slice(0, -newItem.length);
            }
            newItem.forEach((item) => dataCopy.unshift(item));
        }
    } else {
        dataCopy.unshift(newItem);
    }
    return { data: dataCopy };
};

export const addToTableRequest = async (
    url,
    payload,
    setData,
    pathResponse?: (response: any) => any,
    onResponse?: any,
    config?: AxiosRequestConfig
) => {
    const response = await Axios.post(url, payload, config);
    onResponse && onResponse(response);

    setData((prev) => {
        const { count, pageSize, lastPage } = prev?.meta;

        const newCount = count + 1;

        return {
            ...prev,
            meta: { ...prev?.meta, lastPage: newCount % pageSize == 0 ? lastPage + 1 : lastPage, count: newCount },
            ...addToTable(prev, pageSize as number, pathResponse ? pathResponse(response) : response.data.data || response.data),
        };
    });
    return response;
};
